"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.regexp.split");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    form: {
      type: Object
    },
    bookingTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    transportationTermsList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    paidTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    differentKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])), {}, {
    vessNameVoy: function vessNameVoy() {
      return this.form.vesselCode + '.' + this.form.voyageNo + ' ' + this.form.voyageLeg;
    }
  }),
  data: function data() {
    return {
      cargoListType: [{
        code: 0,
        name: 'Export'
      }, {
        code: '1',
        name: 'Reshipment'
      }],
      documentTypeList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$dictionary.get(['DELIVERY_DOCMENT_METHOD'], true).then(function (res) {
      _this.documentTypeList = res.DELIVERY_DOCMENT_METHOD ? res.DELIVERY_DOCMENT_METHOD : [];
    });
  },
  methods: {
    inputClass: function inputClass(fileName) {
      return {
        'different': this.isDifferent(fileName)
      };
    },
    isDifferent: function isDifferent(fileName) {
      var _this2 = this;
      var fileNames = fileName.split(",");
      return fileNames.some(function (name) {
        return _this2.differentKeys.includes(name);
      });
    }
  }
};